import { Box, Stack, type SxProps, type Theme } from "@mui/material";
import type { ReactNode } from "react";

export type ReportControlBarProps = {
  left?: ReactNode;
  center?: ReactNode;
  right?: ReactNode;
  sx?: SxProps<Theme>;
};

/**
 * Top toolbar for report pages: filter controls (left), primary actions (center), utilities (right).
 * Layout is responsive: sections wrap and stay readable on narrow viewports.
 */
const ReportControlBar = ({ left, center, right, sx }: ReportControlBarProps) => {
  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      alignItems="flex-start"
      justifyContent="space-between"
      gap={2}
      sx={sx}
    >
      <Box
        display="flex"
        flexWrap="wrap"
        alignItems="flex-start"
        gap={1.5}
        sx={{ flex: "1 1 auto", minWidth: 0 }}
      >
        {left}
      </Box>
      {center != null && (
        <Stack
          direction="row"
          flexWrap="wrap"
          alignItems="center"
          justifyContent="center"
          gap={1}
          sx={{ flex: "0 1 auto" }}
        >
          {center}
        </Stack>
      )}
      {right != null && (
        <Stack
          direction="row"
          flexWrap="wrap"
          alignItems="center"
          justifyContent="flex-end"
          gap={1}
          sx={{ flex: "0 0 auto" }}
        >
          {right}
        </Stack>
      )}
    </Stack>
  );
};

export default ReportControlBar;
